import { faArrowTrendUp, faArrowsUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";
import Slider from "react-slick";
import '../pricingslider.css'


const HeroSection = ({ isCareerGoal , cardDatas , reviews}) => {
  const [heroPlan, setHeroPlan] = useState(1);
  const [heroTitle , setHeroTitle] = useState('');
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const imageRoutes = ['https://assets.learntube.ai/files/Optimized_folder/PhonePe.svg?updatedAt=1688366006884' ,'https://assets.learntube.ai/files/Optimized_folder/Byjus.svg?updatedAt=1688366004425' , 'https://assets.learntube.ai/files/Optimized_folder/Flipkart.svg?updatedAt=1688366003066' , 'https://assets.learntube.ai/files/Optimized_folder/Myntra.svg?updatedAt=1688366005500' , 'https://assets.learntube.ai/files/Optimized_folder/Ola.svg?updatedAt=1688366006998'];

  const settings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: 'linear',
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          rows: 1,
          speed: 300,
          cssEase: "linear"
        },
      },
    ],
  };
 const userDesignation = { 201737 : 'CRM Executive' , 33015 : 'Application Developer' , 196419 : 'Freelance UI/UX Designer' , 195206 : 'Business Development Manager' , 479672 : 'Senior UI/UX Developer'}
  useEffect(() => {
    if (isCareerGoal?.is_show) {
      if (isCareerGoal?.selected_goal?.product === "LearnTube Pro") {
        setHeroPlan(1);
        setHeroTitle('With LearnTube Pro You Get')
      }
      if (isCareerGoal?.selected_goal?.product === "LearnTubeX") {
        setHeroPlan(2);
        setHeroTitle('With LearnTubeX You Get')
      }
      if (isCareerGoal?.selected_goal?.product === "LearnTube Max") {
        setHeroPlan(3);
        setHeroTitle('LearnTube Max Will Transform Your Life')
      }
    } else {
      if (user_role === 1) {
        setHeroPlan(1);
        setHeroTitle('Upgrade To LearnTube Pro And Build An Amazing Profile!');
      } else if (user_role === 2) {
        setHeroPlan(2);
        setHeroTitle('With LearnTubeX You Get');
      } else if (user_role === 4) {
        setHeroPlan(3);
        setHeroTitle('Upgrade To LearnTube Max And Get Hired Quick!');
      } 
      else if(user_role === 6){
        setHeroPlan(3);
        setHeroTitle('How LearnTube Max Is Transforming Your Life!');
      }
    }
  }, [isCareerGoal,cardDatas]);
  // console.log(imageRoutes)
 
  return (<div className="w-full md:w-7/12 md:mt-10 flex flex-col justify-center items-center">

   <h1 className="w-full  bg-[#C2F0FF] py-2 px-4 leading-tight text-center text-[20px] font-semibold md:text-[32px]  text-[#086788]">
        {heroTitle}
      </h1>
 { heroPlan === 1 ?
     <div className="flex flex-col bg-white mt-10 md:grid grid-cols-2 md:gap-x-3 px-2 justify-center item-center text-md md:text-[24px] w-11/12 md:w-full border-2 rounded-lg py-2">
    <div className="px-4 py-2 border-2 text-center rounded-lg "><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">71%</span>chance of getting selected for Interviews</div>
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2 md:mt-0"><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">10%</span>higher pay than the average <span className="font-bold">starting salary</span></div>
    </div>
    :
   (heroPlan === 2 ?
     <div className="flex flex-col bg-white grid-cols-2 md:gap-x-3 mt-10 px-2 py-2 justify-center item-center text-md md:text-[24px] w-11/12 md:w-full border-2 rounded-lg ">
    <div className="px-4 py-2 border-2 text-center rounded-lg"><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">73%</span>chance of getting hired by:
    <div className="flex flex-row w-full justify-center item-center">
        {
            imageRoutes.map((item)=> <img src={item} className="h-6 ml-1 mr-1" height={24} alt="images"></img>)
        }
    </div>
    </div>
    
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2 md:mt-0"><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">27%</span>higher pay than the average <span className="font-bold">starting salary</span></div>
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2 md:mt-0">Average salary hike of<span className="text-[#2BBD13] ml-1 font-bold">41%</span></div>
   
    </div>
   :
  <div className="flex flex-col bg-white md:grid grid-cols-2 md:gap-x-3 px-2 mt-10 py-2 justify-center item-center text-md md:text-[24px] w-11/12 md:w-full border-2 rounded-lg ">
    <div className="px-4 py-2 border-2 text-center rounded-lg"><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">74%</span>chance of getting hired by:
    <div className="flex flex-row justify-center items-center w-full">
        <img src='https://assets.learntube.ai/files/Optimized_folder/Companys.svg?updatedAt=1688366003209' alt="company images" height={24} className=""></img>
    </div>
    </div>
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2 md:mt-0"><FontAwesomeIcon icon={faArrowTrendUp} className="text-[#2BBD13] mr-2"/><span className="text-[#2BBD13] mr-1 font-bold">88%</span>chance of getting hired by:
    <div className="flex flex-row w-full justify-center item-center">
        {
            imageRoutes.map((item)=> <img src={item} className="h-6 ml-1 mr-1" height={24} alt="images"></img>)
        }
    </div>
    </div>
    
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2"><span className="text-[#2BBD13] mr-1 font-bold">43%</span>higher pay than the average <span className="font-bold">starting salary</span></div>
    <div className="px-4 py-2 border-2 text-center rounded-lg mt-2">Average salary hike of<span className="text-[#2BBD13] ml-1 font-bold">56%</span></div>
   
    </div>
   )
    }
 <div className=" w-9/12 md:w-11/12 mt-4 text-black shadow-xl md:shadow-none rounded-xl pricing-scroll">
      <Slider {...settings}>
        {reviews?.length > 0 &&
          reviews?.map((item, index) => (
            <div className="   flex flex-col justify-center items-center    font-light px-2 md:py-2  ">
              <div className="bg-[#E8F9FF] shadow-lg px-2 py-2 h-[200px] flex flex-col justify-center items-center rounded-lg ">
                <div className="self-center italic text-sm text-pricing_blue text-center">{item?.feedback}</div>
                  <div className="flex flex-row justify-center items-center mt-2">
                    <img src={item?.profile_image} className="w-10 h-10 rounded-full mr-1" width={40} height={40} alt="profile image"></img>
                    <div className='flex flex-col justify-center items-start text-start ml-2'>
                      <div className="text-[12px] md:text-md ">{item?.name}</div>
                      <div className=' text-[#666666] text-[10px] md:text-xs '>{userDesignation[item?.user_id]}</div>
                      
                      </div>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </div>
    </div>)
};


export default HeroSection;
